var React = require('react');

function ShapeHeader (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M1267.62692,1.3719733 C1300.69048,0.732890845 1355.85454,0.732890845 1433.11911,1.3719733 L1432.9994,1.37066146 L1433,20 L0,20 L-0.00359574068,7.37283628 C33.8888471,3.37226096 139.596414,1.3719733 317.119105,1.3719733 C491.283107,1.3719733 626.210388,16.1189956 925.119105,19.969623 C989.121712,20.7941228 1101.25032,4.58785065 1267.62692,1.3719733 Z"}));
}

ShapeHeader.defaultProps = {"viewBox":"0 0 1433 20","version":"1.1","preserveAspectRatio":"none"};

module.exports = ShapeHeader;

ShapeHeader.default = ShapeHeader;
